import {FormInstance} from 'antd/lib/form'
import IDS from '../constants/ids'

type stringOrNumberType = string | number
type NamePathType = string | stringOrNumberType[]
type NamePathsType = NamePathType[]
type ValidationStatus = 'success' | 'error'

class Validator {
    private form: FormInstance

    setForm = form => {
        this.form = form
    }

    validateFirstStep = async (): Promise<ValidationStatus> => {
        //console.log('validateFirstStep')
        const {form} = this

        try {
            const ids: NamePathsType = [
                IDS.INSURANCE_TYPE,
                IDS.CARGO_TYPE,
                IDS.CARGO_LOADING_TYPE,
                IDS.CARGO_PACKAGING,
                IDS.INSURANCE_SUM,
                IDS.FRANCHISE,
            ]

            const values = await form.validateFields(ids)
            console.log('Валидация первого шага успешна. Значения ', values)
            return 'success'
        } catch (e) {
            console.log('Ошибка при валидации первого шага! ', e)
            form.scrollToField(e.errorFields[0].name)
            return 'error'
        }
    }

    validateSecondStep = async (): Promise<ValidationStatus> => {
        const {form} = this

        try {
            const ids: NamePathsType = [
                IDS.DISTANCE_COUNT,
                IDS.DISTANCE_FROM,
                IDS.DISTANCE_TO,
                IDS.TRANSPORT_TYPE,
                IDS.TRANSPORT_GUARD,
                IDS.TRANSPORT_SHIPPING,
                IDS.TRANSPORT_LONG_DELIVERY,
                IDS.TRANSPORT_STORAGE,
                IDS.TRANSPORT_LOADING_COUNT,
            ]

            const values = await form.validateFields(ids)
            console.log('Валидация второго шага успешна. Значения ', values)
            return 'success'
        } catch (e) {
            console.log('Ошибка при валидации второго шага! ', e)
            form.scrollToField(e.errorFields[0].name)
            return 'error'
        }
    }

    validateThirdStep = async (): Promise<ValidationStatus> => {
        const {form} = this

        try {
            const ids: NamePathsType = [
                IDS.CONTACT_NАМЕ,
                IDS.CONTACT_PHONE,
                IDS.EMAIL,
                IDS.CONTACT_COMPANY,
                IDS.AGREEMENT_WITH_PROTECTION_POLICY,
                IDS.AGREEMENT_WITH_RULES,
            ]

            const values = await form.validateFields(ids)
            console.log('Валидация третьего шага успешна. Значения ', values)
            return 'success'
        } catch (e) {
            console.log('Ошибка при валидации третьего шага! ', e)
            form.scrollToField(e.errorFields[0].name)
            return 'error'
        }
    }
}

const validator = new Validator()

export default validator
